import {ChangeDetectorRef, Component, TemplateRef, ViewChild} from '@angular/core';
import {DirectoryComponent} from "../directory/directory.component";
import {ActivatedRoute, Router} from "@angular/router";
import {DirectoryService} from "../../shared/directory.service";
import {NbDialogService} from "@nebular/theme";
import {TranslateService} from "@ngx-translate/core";
import {ColType} from "../../interfaces/colDef";
import {SettingsService} from "../../shared/settings.service";

@Component({
    selector: 'bst-question-directory',
    templateUrl: './question-directory.component.html',
    styleUrls: ['../../project/projects.component.scss', '../directory/directory.component.scss'],
    standalone: false
})
export class QuestionDirectoryComponent extends DirectoryComponent{

  @ViewChild('question', {static: true}) question: TemplateRef<any>;

  ColType = ColType;

  ngOnInit(): void {
    this.bootstrap();
  }

  get namekey(): string{
    return 'question';
  }

  private async bootstrap(){
    this.name = 'questions';
    if(!this.loading.getValue()) {
      const description = await this.describe(this.name);
      const custom = description.colDefs.find(o => o.type === ColType.CUSTOM);
      if(custom){
        custom.display = this.question;
        custom.colDefs = [
          {
            title: 'Type',
            name: 'type',
            required: true,
            type: ColType.SELECT,
            default: ColType.STRING.toString(),
            list: [
              {
                id: ColType.STRING.toString(),
                name: 'Text'
              },
              {
                id: ColType.SCALE.toString(),
                name: 'Scale'
              }
            ]
          },
          {
            title: 'Required',
            name: 'required',
            required: true,
            type: ColType.BOOL,
            default: true
          },
          {
            title: 'Min name',
            name: 'scale_from_name',
            required: false,
            type: ColType.STRING,
            length: 100,
            default: 'Less Experience'
          },
          {
            name: 'scale_steps',
            title: 'Steps',
            required: false,
            type: ColType.INT,
            length: 10,
            default: 5
          },
          {
            title: 'Max name',
            name: 'scale_to_name',
            required: false,
            type: ColType.SLIDER,
            length: 100,
            default: 'More Experience'
          }
        ];
      }
    }
  }

}
